var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcMic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    overflow: "visible",
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Document"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 9,29 C 9,27.896 9.895,27 11,27 L 13,27 C 8.58,27 5,23.42 5,19 L 5,15 C 5,13.896 5.895,13 7,13 C 8.104,13 9,13.896 9,15 L 9,5 C 9,2.792 10.791,1 13,1 L 19,1 C 21.208,1 23,2.792 23,5 L 23,15 C 23,13.896 23.895,13 25,13 C 26.104,13 27,13.896 27,15 L 27,19 C 27,23.42 23.416,27 19,27 L 21,27 C 22.104,27 23,27.896 23,29 C 23,30.105 22.104,31 21,31 L 11,31 C 9.895,31 9,30.105 9,29 Z M 18.999,18.995 L 19,5 L 13.005,5.001 L 13,19 L 18.999,18.995 Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 10,29 C 10,28.448 10.448,28 11,28 L 15,28 L 15,26 L 13,26 C 9.133,26 6,22.867 6,19 L 6,15 C 6,14.448 6.448,14 7,14 C 7.552,14 8,14.448 8,15 L 8,19 C 8,21.761 10.239,24 13,24 L 19,24 C 21.76,24 24,21.761 24,19 L 24,15 C 24,14.448 24.448,14 25,14 C 25.552,14 26,14.448 26,15 L 26,19 C 26,22.867 22.864,26 19,26 L 16.999,26 L 16.999,28 L 21,28 C 21.552,28 22,28.448 22,29 C 22,29.552 21.552,30 21,30 L 11,30 C 10.448,30 10,29.552 10,29 Z M 10,19 C 10,18.651 10,5.351 10,5 C 10,3.344 11.344,2 13,2 L 19,2 C 20.656,2 22,3.344 22,5 C 22,5.351 22,18.651 22,19 C 22,20.656 20.656,22 19,22 L 13,22 C 11.344,22 10,20.656 10,19 Z M 20,19 L 20,5 C 20,4.449 19.551,4 19,4 L 13,4 C 12.448,4 12,4.449 12,5 L 12,19 C 12,19.552 12.448,20 13,20 L 19,20 C 19.551,20 20,19.552 20,19 Z",
    fill: "#eeeeee"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMic);
export default __webpack_public_path__ + "static/media/ic_mic.dfd322078b540826a4766485713178dc.svg";
export { ForwardRef as ReactComponent };